import { RootState } from "../Store";

export const selectOrders = (state: RootState) => state.order.orders;

export const selectNewOrderCount = (state: RootState) =>
  state.order.newOrderCount;
